import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {MenuService} from '../services/menu.service';

export const processGuard: CanActivateFn = async (route) => {

  const router = inject(Router);
  const menuService = inject(MenuService);

  const proceso = route.data?.['proceso'] as string | undefined;

  if (!proceso) {
    console.warn('Ruta sin proceso definido');
    return router.createUrlTree(['/dashboard']);
  }

  // Esperar a que el menú esté listo
  await menuService.ready();

  // Buscar en el menú YA FILTRADO
  const menuItem = menuService.getMenuByRoute(proceso);

  if (!menuItem) {
    console.warn('Proceso no existe en menú construido');
    return router.createUrlTree(['/dashboard']);
  }

  //  Validar permiso en DB
  // const allowed = await permissionDb.can(proceso);
  //
  // if (!allowed) {
  //   console.warn('Usuario sin permiso para proceso');
  //   return router.createUrlTree(['/dashboard']);
  // }

  return true;
};
